import React, { useState, useRef, useEffect } from 'react';
import styles from './SubmitSupportRequest.module.css';
import bgPattern from '../../../../Assets/BRANDING-BG.png';
import { Header } from '../header/Header';
import { DashboardSidebar } from '../DashboardSidebar/DashboardSidebar';

export const SubmitSupportRequest = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [formData, setFormData] = useState({
        subject: '',
        category: '',
        priority: '',
        description: ''
    });
    const toastTimeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (toastTimeoutRef.current) {
                clearTimeout(toastTimeoutRef.current);
            }
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (toastTimeoutRef.current) {
            clearTimeout(toastTimeoutRef.current);
        }
        // Show toast notification
        setShowToast(true);
        // Clear form
        setFormData({
            subject: '',
            category: '',
            priority: '',
            description: ''
        });
        toastTimeoutRef.current = setTimeout(() => {
            setShowToast(false);
            toastTimeoutRef.current = null;
        }, 3000);
    };

    const handleClear = () => {
        setFormData({
            subject: '',
            category: '',
            priority: '',
            description: ''
        });
    };

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.headerWrapper}>
                <Header onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
            </div>

            <div className={styles.mainWrapper}>
                <DashboardSidebar
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                />

                <div className={styles.container} style={{ backgroundImage: `url(${bgPattern})` }}>
                    {/* Toast Notification */}
                    {showToast && (
                        <div className={styles.toast}>
                            Request Submitted
                        </div>
                    )}

                    <div className={styles.pageHeader}>
                        <h1 className={styles.title}>Submit Support Request</h1>
                        <p className={styles.subtitle}>
                            Create a new support request for assistance with your managed services.
                        </p>
                    </div>

                    <div className={styles.formContainer}>
                        <form onSubmit={handleSubmit}>
                            {/* Subject Field */}
                            <div className={styles.formGroup}>
                                <label className={styles.label}>
                                    Subject <span className={styles.required}>*</span>
                                </label>
                                <input
                                    type="text"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleInputChange}
                                    className={styles.input}
                                    required
                                />
                            </div>

                            {/* Category and Priority Row */}
                            <div className={styles.formRow}>
                                <div className={styles.formGroup}>
                                    <label className={styles.label}>
                                        Category <span className={styles.required}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="category"
                                        value={formData.category}
                                        onChange={handleInputChange}
                                        className={styles.input}
                                        required
                                    />
                                </div>

                                <div className={styles.formGroup}>
                                    <label className={styles.label}>
                                        Priority <span className={styles.required}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="priority"
                                        value={formData.priority}
                                        onChange={handleInputChange}
                                        className={styles.input}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Description Field */}
                            <div className={styles.formGroup}>
                                <label className={styles.label}>
                                    Description <span className={styles.required}>*</span>
                                </label>
                                <textarea
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    className={styles.textarea}
                                    rows="8"
                                    required
                                />
                            </div>

                            {/* Form Actions */}
                            <div className={styles.formActions}>
                                <button type="submit" className={styles.submitButton}>
                                    Submit Request
                                </button>
                                <button
                                    type="button"
                                    onClick={handleClear}
                                    className={styles.clearButton}
                                >
                                    Clear
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubmitSupportRequest;
